














































import type { PropType } from '@vue/composition-api';
import copy from 'copy-to-clipboard';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { ModalSize, ButtonType } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import Person from '@getaccept/lib-shared/src/components/Person.vue';
import moment from 'moment';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import { DocumentHelper } from '../../helpers/document.helper';

export default defineComponent({
  name: 'NonActiveDocumentModal',
  components: { Person },
  props: {
    document: {
      type: Object as PropType<SigningPageDocument>,
      default: null,
    },
    isDocumentRecalled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const showCopyTooltip = ref(false);

    const documentName = computed(() => props.document?.name);
    const sender = computed(() => props.document?.user);
    const expirationDate = computed(() => props.document?.expirationDate);
    const isDocumentExpired = computed(() => DocumentHelper.getIsDocumentExpired(props.document));
    const isDocumentRejected = computed(() => props.document?.status === DocumentStatus.Rejected);

    const title = computed(() => {
      if (props.isDocumentRecalled) {
        return t('document-has-been-recalled');
      }

      if (isDocumentExpired.value) {
        return t('document-has-expired');
      }

      if (isDocumentRejected.value) {
        return t('document-has-been-declined');
      }

      return '';
    });

    const text = computed(() => {
      if (props.isDocumentRecalled) {
        return t('document-recalled-lobby-description');
      }

      if (isDocumentExpired.value) {
        return t('document-expired-lobby-description', {
          'document-name': documentName.value,
          'sender-name': sender.value?.fullName,
          'expire-date': moment(expirationDate.value).format('LLL'),
        });
      }

      if (isDocumentRejected.value) {
        return t('document-rejected-lobby-description', {
          'document-name': documentName.value,
          'sender-name': sender.value?.fullName,
        });
      }

      return '';
    });

    const handleCopyEmailToClipboard = () => {
      copy(sender.value.email);
      showCopyTooltip.value = true;
      setTimeout(() => (showCopyTooltip.value = false), 2000);
    };

    const openEmailClient = () => {
      const link = `mailto:${encodeURIComponent(
        `${sender.value.fullName} <${sender.value.email}>`
      )}?subject=${encodeURIComponent(documentName.value)}`;

      window.open(link);
    };

    return {
      title,
      text,
      sender,
      showCopyTooltip,
      handleCopyEmailToClipboard,
      openEmailClient,
      ModalSize,
      ButtonType,
    };
  },
});
